import { DatePicker, FormCard, FormItem, TimeInput } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import dayjs from 'dayjs'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Asterix from '../RotaPattern/components/Asterix'
import type { ModalSectionProps } from '../RotaPattern/utils'
import { getRequiredRule } from '../utils'

type DateTimeWindowProps = {
  type?: 'visit' | 'shift'
  isFlexiType?: boolean
  onStartTimeChanged?: (time?: string) => void
  onEndTimeChanged?: (time?: string) => void
  maxDate?: dayjs.Dayjs
  minDate?: dayjs.Dayjs
} & ModalSectionProps

const DateTimeWindow: FC<DateTimeWindowProps> = ({
  formData,
  onStartTimeChanged,
  onEndTimeChanged,
  maxDate,
  minDate
}) => {
  const { t } = useTranslation()

  return (
    <FormCard level={2} title={t('DATE_AND_TIME_WINDOW')}>
      <FormItem
        name="patternStart"
        label={<Text>{t('START_DATE')}</Text>}
        rules={[getRequiredRule(t('START_DATE'))]}
      >
        <DatePicker
          maxDate={maxDate}
          minDate={minDate}
          disabled={dayjs(formData?.patternStart).isSameOrBefore(dayjs())}
        />
      </FormItem>
      <FormItem
        label={
          <Text>
            <Asterix />
            {t('TIME_WINDOW')}
          </Text>
        }
      >
        <TimeInput
          startTime={formData?.startTime}
          onEndTimeChanged={onEndTimeChanged}
          onStartTimeChanged={onStartTimeChanged}
        />
      </FormItem>
    </FormCard>
  )
}

export default DateTimeWindow
